import script from "./PositioningOrder.vue?vue&type=script&setup=true&lang=ts"
export * from "./PositioningOrder.vue?vue&type=script&setup=true&lang=ts"

import "./PositioningOrder.vue?vue&type=style&index=0&id=10195fd4&scoped=true&lang=css"

import exportComponent from "/home/runner/work/binity-order/binity-order/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-10195fd4"]])

export default __exports__